<template>
  <div
    class="rs-importer-field-icon"
  >
    <i
      :id="`${id}-icon`"
      class="fa-solid fa-hexagon-exclamation"
      :class="`${focused ? 'focused' : ''}`"
    />
    <RsTooltip
      v-if="dataSource && dataSource !== ''"
      :target="`${id}-icon`"
      :title="`This field is managed by ${dataSource}. Changes made will be temporary.`"
      :delay="{ show: 200 }"
      :position="tooltipPosition"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsImporterFieldIcon',
  props: {
    id: {
      type: String,
      required: true,
    },
    dataSource: {
      type: String,
      default: null,
    },
    focused: {
      type: Boolean,
      default: false,
    },
    tooltipPosition: {
      type: String,
      default: 'top',
    },
  },
});
</script>
<style lang="scss">
@import '@/styles/_variables.scss';

.rs-importer-field-icon {
  i {
    color: $tertiary-muted;
    z-index: 100;

    &:hover, &.focused {
      color: $error;
    }
  }
}
</style>
